var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "terms" },
    [
      _c("header", { staticClass: "terms__header" }, [
        _c("h2", [_vm._v("Terms of Use")]),
        _vm._v(" "),
        _c("span", [_vm._v("Last updated: March 25, 2024")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "img",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _c("img", {
              attrs: { src: _vm.mediaBaseUrl + "close.svg", alt: "close" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("terms-of-services-text")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }